//This function can be re-used for other search components too

import { useEffect, useState } from "react";

 export function useDebouncedSearch(value:string,length:number,delay:number){
      const [debounced,setDebounced]=useState(value);
      useEffect(()=>{
          const timer = setTimeout(() => {
        if (value.length >= length) {
          setDebounced(value);
        }
      }, delay);
      return () => clearTimeout(timer);
      },[value,delay,length])
      return debounced
  }
